<template>
  <div class="eu-basis_9 eu-flex">
    <div class="eu-flex-item eu-basis_6 eu-basis_5_md">
      <div class="emd-form-group">
        <label class="emd-label">{{ $t('discountValue') }}</label>
        <emd-input-money v-model="discountValue" @input="changeDiscount" :prefix="prefix" :numberFormat="numberFormat" />
      </div>
    </div>
    <div class="eu-flex-item eu-basis_6 eu-basis_6_md">
      <div class="emd-form-group">
        <label class="emd-label">{{ $t('discountFormat') }}</label>
        <div class="emd-select">
          <select v-model="discountFormat" @change="changeDiscount">
            <option v-for="(item, index) in formats" :key="index" :value="item.value">{{ $t(`formats.${item.value}`) }}</option>
          </select>
          <div class="emd-select__arrow"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmdInputMoney from '@/components/project/EmdInputMoney'
import { isPercentageFormat } from '@/enums/discount.enum'

export default {
  name: 'Discount',
  components: {
    EmdInputMoney
  },
  data () {
    return {
      discountValue: 1000,
      discountFormat: 'percentage',
      formats: [
        {
          value: 'percentage'
        },
        {
          value: 'money'
        }
      ]
    }
  },
  computed: {
    prefix () {
      return isPercentageFormat(this.discountFormat) ? '%' : 'R$'
    },
    numberFormat () {
      return isPercentageFormat(this.discountFormat) ? 'decimal' : 'integer'
    }
  },
  methods: {
    changeDiscount () {
      this.$emit('changeDiscount', {
        discountFormat: this.discountFormat,
        discountValue: this.discountValue
      })
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "discountValue": "Valor do desconto",
    "discountFormat": "Formato do desconto",
    "formats": {
      "money": "Real (R$)",
      "percentage": "Percentual (%)"
    }
  },
  "en-US": {
    "discountValue": "Discount value",
    "discountFormat": "Discount format",
    "formats": {
      "money": "Real (R$)",
      "percentage": "Percentage (%)"
    }
  }
}
</i18n>
